import { elementVersions } from "../config/form_builder/index";

export const getElementComponentLastVersion = elementName => {
  const element = elementVersions[elementName];
  return element.lastVersion;
};

export const getElementComponentConfig = elementName => {
  const element = elementVersions[elementName];
  return element;
};

export const getElementComponentData = (elementName, elementVersion) => {
  const element = elementVersions[elementName];
  if (!elementVersion) elementVersion = element.lastVersion;
  const version = element.versions[elementVersion];
  return version;
};

export const getElementComponents = () => {
  const components = Object.keys(elementVersions)
    .filter(element => {
      return elementVersions[element].type == "component";
    })
    .map(element => ({
      ...elementVersions[element],
      elType: element
    }));
  return components;
};

export const getElementComponentLayoutProperties = (
  elementName,
  elementVersion
) => {
  const element = elementVersions[elementName];
  return element.versionLayoutProperties
    ? element.versionLayoutProperties[elementVersion]
    : [];
};

const getElementIndex = (elementId, elementType) => {
  return parseInt(elementId.substr(elementType.length), 10);
};

const getElementsLastIndex = json => {
  let elementsLastIndex = {};
  for (let rowIndex = 0; rowIndex < json.rows.length; rowIndex++) {
    const row = json.rows[rowIndex];
    if (!elementsLastIndex["Row"])
      elementsLastIndex["Row"] = getElementIndex(row.id, "Row");
    else if (getElementIndex(row.id, "Row") > elementsLastIndex["Row"])
      elementsLastIndex["Row"] = getElementIndex(row.id, "Row");
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (!elementsLastIndex["Column"])
        elementsLastIndex["Column"] = getElementIndex(column.id, "Column");
      else if (
        getElementIndex(column.id, "Column") > elementsLastIndex["Column"]
      )
        elementsLastIndex["Column"] = getElementIndex(column.id, "Column");
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (!elementsLastIndex[component.elType])
            elementsLastIndex[component.elType] = getElementIndex(
              component.id,
              component.elType
            );
          else if (
            getElementIndex(component.id, component.elType) >
            elementsLastIndex[component.elType]
          )
            elementsLastIndex[component.elType] = getElementIndex(
              component.id,
              component.elType
            );

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let index = 0;
            index < componentLayoutProperties.length;
            index++
          ) {
            const layoutProperty = componentLayoutProperties[index];
            const layoutElementsLastIndex = getElementsLastIndex(
              component.properties[layoutProperty]
            );
            const layoutlayoutElementsLastIndexTypes = Object.keys(
              layoutElementsLastIndex
            );
            for (
              let index = 0;
              index < layoutlayoutElementsLastIndexTypes.length;
              index++
            ) {
              const layoutlayoutElementsLastIndexType =
                layoutlayoutElementsLastIndexTypes[index];
              if (!elementsLastIndex[layoutlayoutElementsLastIndexType])
                elementsLastIndex[layoutlayoutElementsLastIndexType] =
                  layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
              else if (
                layoutElementsLastIndex[layoutlayoutElementsLastIndexType] >
                elementsLastIndex[layoutlayoutElementsLastIndexType]
              )
                elementsLastIndex[layoutlayoutElementsLastIndexType] =
                  layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
            }
          }
        }
      }
      if (column.layout) {
        const layoutElementsLastIndex = getElementsLastIndex(column.layout);
        const layoutlayoutElementsLastIndexTypes = Object.keys(
          layoutElementsLastIndex
        );
        for (
          let index = 0;
          index < layoutlayoutElementsLastIndexTypes.length;
          index++
        ) {
          const layoutlayoutElementsLastIndexType =
            layoutlayoutElementsLastIndexTypes[index];
          if (!elementsLastIndex[layoutlayoutElementsLastIndexType])
            elementsLastIndex[layoutlayoutElementsLastIndexType] =
              layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
          else if (
            layoutElementsLastIndex[layoutlayoutElementsLastIndexType] >
            elementsLastIndex[layoutlayoutElementsLastIndexType]
          )
            elementsLastIndex[layoutlayoutElementsLastIndexType] =
              layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
        }
      }
    }
  }
  return elementsLastIndex;
};

export const getElementUniqueId = (json, elementType) => {
  const elementsLastIndex = getElementsLastIndex(json);
  return (
    elementType +
    (elementsLastIndex[elementType] ? elementsLastIndex[elementType] + 1 : 1)
  );
};

export const getElementFromId = (json, elementId) => {
  if (json.id == elementId.id) return json;
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    if (row.id == elementId) return row;
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.id == elementId) return column;
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (component.id == elementId) return component;

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutElement = getElementFromId(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              elementId
            );
            if (layoutElement) return layoutElement;
          }
        }
      }
      if (column.layout) {
        const layoutElement = getElementFromId({ ...column }, elementId);
        if (layoutElement) return layoutElement;
      }
    }
  }
  return null;
};

export const getFormBuilderComponents = json => {
  let components = [];
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.components) {
        components = [...components, ...column.components];
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            components = [
              ...components,
              ...getFormBuilderComponents({
                id: component.id,
                layout: component.properties[layoutProperty]
              })
            ];
          }
        }
      }

      if (column.layout) {
        components = [
          ...components,
          ...getFormBuilderComponents({ ...column })
        ];
      }
    }
  }
  return components;
};

export const getFormBuilderSelectedElement = (
  json,
  selectedElementControlId
) => {
  if (json.id == selectedElementControlId) return json;
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    if (row.id == selectedElementControlId) return row;
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.id == selectedElementControlId) return column;
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (component.id == selectedElementControlId) return component;

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutSelectedElement = getFormBuilderSelectedElement(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              selectedElementControlId
            );
            if (layoutSelectedElement) return layoutSelectedElement;
          }
        }
      }
      if (column.layout) {
        const layoutSelectedElement = getFormBuilderSelectedElement(
          column,
          selectedElementControlId
        );
        if (layoutSelectedElement) return layoutSelectedElement;
      }
    }
  }
  return null;
};

export const setFormBuilderSelectedElement = (json, newSelectedElement) => {
  if (json.id == newSelectedElement.id) json = newSelectedElement;
  else {
    for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
      const row = json.layout.rows[rowIndex];
      if (row.id == newSelectedElement.id)
        json.layout.rows[rowIndex] = newSelectedElement;
      for (
        let columnIndex = 0;
        columnIndex < row.columns.length;
        columnIndex++
      ) {
        const column = row.columns[columnIndex];
        if (column.id == newSelectedElement.id)
          row.columns[columnIndex] = newSelectedElement;
        if (column.components) {
          for (
            let componentIndex = 0;
            componentIndex < column.components.length;
            componentIndex++
          ) {
            const component = column.components[componentIndex];
            if (component.id == newSelectedElement.id)
              column.components[componentIndex] = newSelectedElement;
            else {
              const componentLayoutProperties = getElementComponentLayoutProperties(
                component.elType,
                component.version
              );
              for (
                let componentLayoutIndex = 0;
                componentLayoutIndex < componentLayoutProperties.length;
                componentLayoutIndex++
              ) {
                const layoutProperty =
                  componentLayoutProperties[componentLayoutIndex];
                const layoutJson = setFormBuilderSelectedElement(
                  {
                    id: component.id,
                    layout: component.properties[layoutProperty]
                  },
                  newSelectedElement
                );
                row.columns[columnIndex].components[componentIndex].properties[
                  layoutProperty
                ] = layoutJson.layout;
              }
            }
          }
        }
        if (column.layout) {
          const layoutJson = setFormBuilderSelectedElement(
            { ...column },
            newSelectedElement
          );
          row.columns[columnIndex] = layoutJson;
        }
      }
    }
  }
  return json;
};

export const removeFormBuilderMovingComponent = (json, movingComponentId) => {
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutJson = removeFormBuilderMovingComponent(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              movingComponentId
            );
            row.columns[columnIndex].components[componentIndex].properties[
              layoutProperty
            ] = layoutJson.layout;
          }
          if (component.id == movingComponentId) {
            column.components.splice(componentIndex, 1);
          }
        }
      }
      if (column.layout) {
        const layoutJson = removeFormBuilderMovingComponent(
          { ...column },
          movingComponentId
        );
        row.columns[columnIndex] = layoutJson;
      }
    }
  }
  return json;
};

export const removeFormBuilderEmptySpaces = json => {
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.components) {
        if (
          json.layout.rows[rowIndex].columns[columnIndex].components.length == 0
        ) {
          json.layout.rows[rowIndex].columns.splice(columnIndex, 1);
          columnIndex--;
        } else {
          for (
            let componentIndex = 0;
            componentIndex < column.components.length;
            componentIndex++
          ) {
            const component = column.components[componentIndex];

            const componentLayoutProperties = getElementComponentLayoutProperties(
              component.elType,
              component.version
            );
            for (
              let componentLayoutIndex = 0;
              componentLayoutIndex < componentLayoutProperties.length;
              componentLayoutIndex++
            ) {
              const layoutProperty =
                componentLayoutProperties[componentLayoutIndex];
              const layoutJson = removeFormBuilderEmptySpaces({
                id: component.id,
                layout: component.properties[layoutProperty]
              });
              row.columns[columnIndex].components[componentIndex].properties[
                layoutProperty
              ] = layoutJson.layout;
            }
          }
        }
      }
      if (column.layout) {
        const layoutJson = removeFormBuilderEmptySpaces({ ...column });
        row.columns[columnIndex] = layoutJson;
      }
    }
    if (json.layout.rows[rowIndex].columns.length == 0) {
      json.layout.rows.splice(rowIndex, 1);
      rowIndex--;
    }
  }
  return json;
};

export const getFormJsonBaked = (json, computedProperties) => {
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    if (computedProperties[row.id])
      json.layout.rows[rowIndex].properties = {
        ...json.layout.rows[rowIndex].properties,
        ...computedProperties[row.id]
      };
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (computedProperties[column.id])
        json.layout.rows[rowIndex].columns[columnIndex].properties = {
          ...json.layout.rows[rowIndex].columns[columnIndex].properties,
          ...computedProperties[column.id]
        };
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (computedProperties[component.id])
            json.layout.rows[rowIndex].columns[columnIndex].components[
              componentIndex
            ].properties = {
              ...json.layout.rows[rowIndex].columns[columnIndex].components[
                componentIndex
              ].properties,
              ...computedProperties[component.id]
            };

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutJson = getFormJsonBaked(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              computedProperties
            );
            row.columns[columnIndex].components[componentIndex].properties[
              layoutProperty
            ] = layoutJson.layout;
          }
        }
      }
      if (column.layout) {
        const layoutJson = getFormJsonBaked({ ...column }, computedProperties);
        row.columns[columnIndex] = layoutJson;
      }
    }
  }
  return json;
};

export const valueOrOther = value => {
  if (!value) return "";
  if (value.value == "Other") return value.otherValue;
  return value.value;
};

export const getDependencies = layout => {
  let dependencies = {};
  layout.rows.forEach(row => {
    row.columns.forEach(col => {
      col.components.forEach(component => {
        if (component.properties) {
          for (const [key, value] of Object.entries(component.properties)) {
            if (typeof value == "string" && value.includes("{{") &&
            value.includes("}}")){
              let results = value.match(/components[.[][']*[A-Za-z]+[0-9]+[_']*/g);
              if (results){
                results.forEach(res => {
                  let id = res.replace(/components|\.|'|\[/g, "");
                  let index = id.indexOf("_");
                  id = id.substring(0, index < 0 ? id.length : index);
                  let obj = {
                    property: key,
                    element: component.id
                  };
                  if(!dependencies[id]) {
                    dependencies[id] = [];
                  }
                  if (!dependencies[id].some(e => e.property == key && e.element == component.id)) {
                    dependencies[id].push(obj);
                  }
                });
              }

              results = value.match(/components[.[][']*Crud[0-9]+.Value[[]elementIndex\(\)\][.[][']*[A-Za-z]+[0-9]+[_']*/g);
              if (results){
                results.forEach(res => {
                  let id = res.replace(/components[.[][']*Crud[0-9]+.Value[[]elementIndex\(\)][.[][']*/g, "");
                  let index = id.indexOf("_");
                  id = id.substring(0, index < 0 ? id.length : index);
                  let obj = {
                    property: key,
                    element: component.id
                  };
                  if(!dependencies[id]) {
                    dependencies[id] = [];
                  }
                  if (!dependencies[id].some(e => e.property == key && e.element == component.id)) {
                    dependencies[id].push(obj);
                  }
                });
              }
            }
            else if(component.elType == "Table") {
              if (key == "columns") {
                value.forEach((tableCol, columnIndex) => {
                  if (tableCol.label.includes("{{") &&
                  tableCol.label.includes("}}")){
                    let results = tableCol.label.match(/components[.[][']*[A-Za-z]+[0-9]+[_']*/g);
                    if (results){
                      results.forEach(res => {
                        let id = res.replace(/components|\.|'|\[/g, "");
                        let index = id.indexOf("_");
                        id = id.substring(0, index < 0 ? id.length : index);
                        let obj = {
                          property: "columns",
                          element: component.id,
                          type: component.elType,
                          columnIndex: columnIndex
                        };
                        if(!dependencies[id]) {
                          dependencies[id] = [];
                        }
                        if (!dependencies[id].some(e => e.property == "columns" 
                          && e.element == component.id && e.type == component.elType && e.index == columnIndex)) {
                          dependencies[id].push(obj);
                        }
                      });
                    }
                  }  
                });
              }
              if (key == "items") {
                value.forEach((tableItem, itemIndex) => {
                  Object.entries(tableItem).forEach(([itemKey, itemValue], columnIndex) => {  
                    if (itemValue.includes("{{") &&
                    itemValue.includes("}}")){
                      let results = itemValue.match(/components[.[][']*[A-Za-z]+[0-9]+[_']*/g);
                      if (results){
                        results.forEach(res => {
                          let id = res.replace(/components|\.|'|\[/g, "");
                          let index = id.indexOf("_");
                          id = id.substring(0, index < 0 ? id.length : index);
                          let obj = {
                            property: "items",
                            element: component.id,
                            type: component.elType,
                            itemKey: itemKey,
                            itemIndex: itemIndex,
                            columnIndex: columnIndex
                          };
                          if(!dependencies[id]) {
                            dependencies[id] = [];
                          }
                          if (!dependencies[id].some(e => e.property == "items" 
                            && e.element == component.id && e.type == component.elType && e.itemKey == itemKey && e.itemIndex == itemIndex
                            && e.columnIndex == columnIndex)) {
                            dependencies[id].push(obj);
                          }
                        });
                      }
                    }
                });
                });
              }
            }
          }
          let dependentProperties = component.properties["dependentProperties"];
          if (dependentProperties) {
            for (const [key, value] of Object.entries(dependentProperties)) {
              let obj = {
                property: key,
                element: component.id
              };
              for (let elemId of value) {
                let index = elemId.indexOf("_");
                elemId = elemId.substring(0, index < 0 ? elemId.length : index);
                if(!dependencies[elemId]) {
                  dependencies[elemId] = [];
                }
                if (!dependencies[elemId].some(e => e.property == key && e.element == component.id)) {
                  dependencies[elemId].push(obj);
                }
              }
            }
          }
        }
        if (component.elType == "Crud") {
          let listItemDependencies = getDependencies(component.properties.listItemLayout);
          let formDependencies = getDependencies(component.properties.formLayout);
          const merge_objs = (o1, o2) => Object.assign({}, ...Array.from(new Set([...Object.keys(o1), ...Object.keys(o2)])).map(k => ({[k]: [...o1[k]??[], ...o2[k]??[]]})));
          let union = merge_objs(listItemDependencies,formDependencies);
          for (const [elemId, listOfDeps] of Object.entries(union)) {
            for (const dep of listOfDeps) {
              if(!dependencies[elemId]) {
                dependencies[elemId] = [];
              }
              if (!dependencies[elemId].some(e => e.property == dep.property && e.element == dep.element)) {
                dependencies[elemId].push(dep);
              }
            }
          }
        }
      });
    });
  });
  return dependencies; 
}
